import React, { useState } from 'react';
import noImage from '../asset/image/no-image-icon.png';
import {url} from './resapi'
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css'
const AboutMember =(props)=>{

  const [swiper, setSwiper] = useState(null);
  const params = {
    Swiper,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    }
  }
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
 
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };
  return(
    <div className="slide_recommend">
    <div className="title">{props.title}</div>
    <div className="row" style={{fontSize:"4em"}}>
        <Swiper {...params} getSwiper={setSwiper}>
        {props.data.map((data,key)=>
         <div className="col-lg-3 col-md-6 col-12 mb-1" key={key}>
            <div className="post">
            <div className="image">
            <img src={data.img?url+"/"+data.img:noImage} alt={data.name}/>
            </div>
            <div className="txt">
              <span className="title">{data.name}</span>
              <span className="job">{data.actor}</span>
            </div>
            </div>
          </div>
        )}
        </Swiper>
      <div className="arrow">
        <span className="left clickable" onClick={goPrev}><i className="icon icon-arrow-left"></i></span>
        <span className="right clickable" onClick={goNext}><i className="icon icon-arrow-right"></i></span>
      </div>
    </div>
  </div>
  )
}
export default AboutMember